import { useMemo } from 'react';

import { EFFECT_DEFAULT_VALUE } from 'constants/params';
import { FileConfig, ConfigFlags as FileConfigFlags } from 'services/file.service';
import { ConfigFlags as ClipConfigFlags } from 'services/clip.service';
import { useAppSelector } from 'store/store-hooks';
import { Clip } from 'components/app/editor/_mediator/editor.slice';
import { CssFilter } from './use-css-filter';

export const useCssFilterClip = (key: keyof CssFilter, clip?: Clip, fileConfig?: FileConfig): number => {
  const adjustment = useAppSelector((state) => state.editor.effectsAdjustment);
  const configPanel = useAppSelector((state) => state.editor.configPanel);
  const activeClip = useAppSelector((state) => state.editor.activeClip);

  const isActive = clip && activeClip === clip.clipId;

  const isClipCheck = useMemo(() => {
    if (!clip) return;
    return clip.config.flags.includes(ClipConfigFlags[key]);
  }, [clip]);

  const isAdjustment = useMemo(() => {
    if (!fileConfig) return;
    if (isClipCheck && isActive && configPanel === 'clip') return true;
    if (!isClipCheck && fileConfig.flags.includes(FileConfigFlags[key]) && configPanel === 'file') return true;
  }, [fileConfig, isClipCheck, isActive, configPanel]);

  return useMemo(() => {
    if (!fileConfig) return EFFECT_DEFAULT_VALUE;
    if (isAdjustment) return adjustment[key];
    if (clip && isClipCheck) return clip.config[key];
    if (fileConfig.flags.includes(FileConfigFlags[key])) return fileConfig[key];
    return EFFECT_DEFAULT_VALUE;
  }, [isClipCheck, clip, fileConfig, isAdjustment && adjustment[key]]);
};
